import { Sheet, SheetContent } from '@/components/shadcn/sheet'
import { ReactNode, Suspense, useState } from 'react'
import { SheetComponentRenderer } from '../../SheetComponentRenderer'
import { getSheetContentLayout } from '../../sheetContentLayout'
import { FormData } from '../../DataFormComponent/types'
import { JsonFormPropertyV2 } from '../../FormComponent/types'
import { DataTableV2DataRow } from '../../DataTableV2/types'
import {
  StatementEditorV2ContentDataType,
  StatementEditorV2SheetContentAction,
} from '../types'

export function SheetContentAction({
  action,
  trigger,
  formData,
  isDisabled,
  onSubmitOverride,
}: {
  action: StatementEditorV2SheetContentAction
  formData?: StatementEditorV2ContentDataType | Record<string, unknown>
  trigger: ReactNode
  isDisabled?: boolean
  onSubmitOverride?: (groupId: string, data: FormData, formProperties: JsonFormPropertyV2[]) => void
}) {
  const [isOpen, setIsOpen] = useState(false)
  const { contentId, contentType } = action.content
  const { side, className } = getSheetContentLayout(contentType)
  const onOpenChange = (open: boolean) => {
    if (!isDisabled) {
      setIsOpen(open)
    }
  }
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      {trigger}
      <SheetContent side={side} className={className}>
        <Suspense fallback={<div>Loading...</div>}>
          <SheetComponentRenderer
            contentType={contentType}
            contentId={contentId}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            actionId={action.id}
            formData={formData as DataTableV2DataRow | undefined}
            onSubmitOverride={onSubmitOverride}
          />
        </Suspense>
      </SheetContent>
    </Sheet>
  )
}
